import { SessionStorageKey } from '../enums/SessionStorageKey';

export function useAuthorized(): boolean {
  return Boolean(sessionStorage.getItem(SessionStorageKey.Token) && sessionStorage.getItem(SessionStorageKey.Username));
}
